import {FilterCondition, FilterFieldDef, FilterJoinMode, CONDITION_OPS, isConditionComplete} from './recordFilterEngine';

/** Explain invalid inputs and impossible AND bounds without silently changing the query. */
export function recordFilterWarnings(conditions: FilterCondition[], fields: FilterFieldDef[], join: FilterJoinMode): string[] {
  const warnings = new Set<string>();
  const ranges = new Map<string, {label: string; low: number; high: number; lowOpen: boolean; highOpen: boolean; integer: boolean}>();
  for (const c of conditions || []) {
    const field = fields.find(f => f.id === c.field);
    if (!field || field.type !== 'metric' || !isConditionComplete(c, fields)) continue;
    const count = CONDITION_OPS[c.op]?.args || 0;
    const values = [c.value, c.value2].slice(0, count).map(Number);
    if (values.some(v => !Number.isFinite(v))) { warnings.add(`${field.label}: enter a finite number.`); continue; }
    if (field.unit === 'percent' && values.some(v => v < 0 || v > 100)) warnings.add(`${field.label}: enter a percentage from 0 to 100.`);
    if (field.unit === 'count' && values.some(v => v < 0 || !Number.isInteger(v))) warnings.add(`${field.label}: enter a whole number of zero or more.`);
    if (count === 2 && values[0] > values[1]) warnings.add(`${field.label}: the first bound must not exceed the second.`);
    if (join !== 'AND' || !['gte','gt','lte','lt','eq','between'].includes(c.op)) continue;
    const r = ranges.get(field.id) || {label:field.label,low:-Infinity,high:Infinity,lowOpen:false,highOpen:false,integer:field.unit === 'count'};
    const lower = (v: number, open: boolean) => { if(v > r.low) {r.low=v;r.lowOpen=open;} else if(v === r.low) r.lowOpen=r.lowOpen || open; };
    const upper = (v: number, open: boolean) => { if(v < r.high) {r.high=v;r.highOpen=open;} else if(v === r.high) r.highOpen=r.highOpen || open; };
    if (['gte','gt','eq','between'].includes(c.op)) lower(values[0],c.op === 'gt');
    if (['lte','lt','eq','between'].includes(c.op)) upper(c.op === 'between' ? values[1] : values[0],c.op === 'lt');
    ranges.set(field.id,r);
  }
  for (const r of ranges.values()) {
    const low = r.integer ? (r.lowOpen ? Math.floor(r.low)+1 : Math.ceil(r.low)) : r.low;
    const high = r.integer ? (r.highOpen ? Math.ceil(r.high)-1 : Math.floor(r.high)) : r.high;
    if(low > high || (!r.integer && low === high && (r.lowOpen || r.highOpen))) warnings.add(`${r.label}: these AND filters cannot match any value.`);
  }
  return [...warnings];
}
